import { useEffect } from 'react';

import { useMap } from 'react-leaflet';

type TMapResizerProps = {
  visible: boolean;
};

export const MapResizer = ({ visible }: TMapResizerProps) => {
  const map = useMap();

  useEffect(() => {
    if (!visible) return undefined;

    const firstResize = setTimeout(() => map.invalidateSize(), 100);
    const secondResize = setTimeout(() => map.invalidateSize(), 300);

    return () => {
      clearTimeout(firstResize);
      clearTimeout(secondResize);
    };
  }, [map, visible]);

  return null;
};
